<template>
  <div class="tcvelik-main-toolbar">
    <div class="flex items-center space-x-1">
      <AlignmentButtons :editor="editor" />
      <div class="divider"></div>
      
      <LineManagementButtons 
        :editor="editor" 
        @add-line-above="$emit('add-line-above')"
        @add-line-below="$emit('add-line-below')"
      />
      <div class="divider"></div>
      
      <TextFormattingButtons 
        :editor="editor" 
        ref="headingDropdown"
      />
      <div class="divider"></div>
      
      <ListButtons 
        :editor="editor"
        @add-manual-step="$emit('add-manual-step', $event)"
        @add-custom-html="$emit('add-custom-html')"
        @open-st-list="$emit('open-st-list')"
      />
      <div class="divider"></div>
      
      <ContentButtons 
        :editor="editor"
        @open-link-menu="$emit('open-link-menu')"
        @open-image-menu="$emit('open-image-menu')"
      />
      <div class="divider"></div>
      
      <FileOperationsButtons 
        :editor="editor"
        @open="$emit('open')"
        @save="$emit('save')"
        @clear-all="$emit('clear-all')"
        @share="$emit('share')"
        @assign="$emit('assign')"
        @assign-role="$emit('assign-role')"
        @add-space="$emit('add-space')"
        @properties="$emit('properties')"
        @delete="$emit('delete')"
      />
      <div class="divider"></div>
      
      <AdvancedButtons 
        :editor="editor"
        @open-html-edit="$emit('open-html-edit',editor.getHTML())"
      />
    </div>
  </div>
</template>

<script>
import AlignmentButtons from './groups/AlignmentButtons.vue'
import LineManagementButtons from './groups/LineManagementButtons.vue'
import TextFormattingButtons from './groups/TextFormattingButtons.vue'
import ListButtons from './groups/ListButtons.vue'
import ContentButtons from './groups/ContentButtons.vue'
import FileOperationsButtons from './groups/FileOperationsButtons.vue'
import AdvancedButtons from './groups/AdvancedButtons.vue'

export default {
  name: 'MainToolbar',
  
  components: {
    AlignmentButtons,
    LineManagementButtons,
    TextFormattingButtons,
    ListButtons,
    ContentButtons,
    FileOperationsButtons,
    AdvancedButtons
  },

  props: {
    editor: {
      type: Object,
      required: true
    }
  },

  methods: {
    updateHeadingDisplay(tagName) {
      this.$refs.headingDropdown.updateHeadingDisplay(tagName)
    }
  }
}
</script> 
